export default "__VITE_ASSET__Fm8pj3OU__"